import { Link, NavLink } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { NAV } from "./navConfig";
import MobileMenuContent from "./MobileMenuContent";

const mobileLinkTestId = (label) => `mobile-nav-${label.toLowerCase().replace(/\s+/g, "-")}`;

/** One accordion row: icon + label link, chevron toggles the sub-menu. */
function MobileNavSection({ item, open, onToggle }) {
  const Icon = item.icon;
  return (
    <div data-testid={`mobile-${item.key}-group`}>
      <div className="flex items-center justify-between">
        <NavLink
          to={item.to}
          end={item.to === "/"}
          data-testid={mobileLinkTestId(item.label)}
          className={({ isActive }) =>
            `flex-1 flex items-center gap-2.5 py-2.5 text-sm font-medium ${isActive ? "text-topo" : "text-slate-700"}`
          }
        >
          <Icon className="h-4 w-4" strokeWidth={1.75} /> {item.label}
        </NavLink>
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={open}
          aria-label={`Toggle ${item.label} menu`}
          data-testid={`mobile-${item.key}-toggle`}
          className="h-9 w-9 inline-flex items-center justify-center rounded-sm text-slate-500 hover:bg-slate-100"
        >
          <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
        </button>
      </div>
      {open && (
        <div className="pl-3 border-l border-slate-200 ml-2 mb-3 animate-in fade-in-0 slide-in-from-top-1 duration-200">
          <MobileMenuContent item={item} />
        </div>
      )}
    </div>
  );
}

/** Mobile drawer (visible <xl). */
export default function MobileNav({ mobileKey, toggleMobileKey }) {
  return (
    <div
      className="xl:hidden border-t border-slate-200 bg-white max-h-[calc(100vh-4rem)] overflow-y-auto"
      data-testid="mobile-menu"
    >
      <div className="px-6 py-3 flex flex-col divide-y divide-slate-100">
        {NAV.map((item) => (
          <MobileNavSection
            key={item.key}
            item={item}
            open={mobileKey === item.key}
            onToggle={() => toggleMobileKey(item.key)}
          />
        ))}
        <div className="pt-3">
          <Link
            to="/contact"
            data-testid="mobile-cta-quote"
            className="w-full inline-flex items-center justify-center rounded-sm bg-orange-survey text-white text-sm font-semibold px-4 py-2"
          >
            Get a Quote
          </Link>
        </div>
      </div>
    </div>
  );
}
